import { createSingleInterpolatedTranslationKey, TranslatableText, useTranslate } from '@dreryk/react-common';

import { appointmentsTranslationKeys } from '../../../../translations';
import { AppointmentConfirmationStatus } from '../../AppointmentsFilterPanel/fields/AppointmentConfirmationStatusField/AppointmentConfirmationStatusField.types';
import { getAppointmentConfirmationStatusFilterCount } from '../../AppointmentsFilterPanel/fields/AppointmentConfirmationStatusField/AppointmentConfirmationStatusField.utils';

const FILTER_SEPARATOR = ', ';

export const useAppointmentConfirmationStatusFilterLabel = (
   appointmentConfirmationStatuses: AppointmentConfirmationStatus[]
): TranslatableText => {
   const translate = useTranslate();

   if (appointmentConfirmationStatuses.length === getAppointmentConfirmationStatusFilterCount()) {
      return createSingleInterpolatedTranslationKey(
         appointmentsTranslationKeys.appointmentConfirmationStatusFilter.filterLabel,
         'confirmationStatuses',
         translate(appointmentsTranslationKeys.appointmentConfirmationStatusFilter.filterLabelAll)
      );
   }

   return createSingleInterpolatedTranslationKey(
      appointmentsTranslationKeys.appointmentConfirmationStatusFilter.filterLabel,
      'confirmationStatuses',
      appointmentConfirmationStatuses
         .map((appointmentConfirmationStatus) =>
            translate(appointmentsTranslationKeys.appointmentConfirmationStatusMap[appointmentConfirmationStatus])
         )
         .join(FILTER_SEPARATOR)
   );
};
